class SlidePanel extends HTMLElement {
  constructor() {
    super();

    // Generate unique ID for this panel
    this.panelId = `slide-panel-${Math.random().toString(36).substr(2, 9)}`;

    // Get panel and store reference before moving it
    this.panel = this.querySelector('.slide-panel-content');
    if (this.panel) {
      this.panel.id = this.panelId;
      // Move panel to body
      document.body.appendChild(this.panel);

      this.toggleButton = this.querySelector('button[data-action="toggle"]');
      this.closeButtons = this.panel.querySelectorAll('button[data-action="close"]');

      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', this.toggle.bind(this));
      }
      if (this.closeButtons) {
        this.closeButtons.forEach(button => {
          button.addEventListener('click', this.close.bind(this));
        });
      }

      document.addEventListener('keyup', (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE' && this.isOpen()) {
          this.close();
        }
      });
    }

  }

  isOpen() {
    const panelEl = document.getElementById(this.panelId);
    if (panelEl) {
      return panelEl.classList.contains('is-open');
    }
    return false;
  }

  toggle(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  onBodyClick(event) {
    if (event.target.tagName.toLowerCase() === 'slide-panel') {
      this.close(false);
    }
  }

  open() {
    // Close all currently open slide panels first
    document.querySelectorAll('slide-panel').forEach(panel => {
      // Ensure panel is an instance of SlidePanel before calling methods
      if (panel !== this && panel instanceof SlidePanel && panel.isOpen()) {
        if (typeof panel.close === "function") {
          panel.close(false);
        }
      }
    });

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Add slide-in animation class
    this.classList.add('is-open');
    const panelEl = document.getElementById(this.panelId);
    if (panelEl) {
      panelEl.classList.add('is-open');
    }
    document.body.classList.add('slide-panel-open');
  }

  close(focusToggle = true) {

    // Remove slide-in class to trigger animation
    this.classList.remove('is-open');
    const panelEl = document.getElementById(this.panelId);
    if (panelEl && panelEl.classList.contains('is-open')) {
      panelEl.classList.remove('is-open');
    }
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    document.body.classList.remove('slide-panel-open');
  }
}

customElements.define('slide-panel', SlidePanel);

// allow other buttons to trigger slide panels
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-panel-trigger]').forEach(button => {
    if (button instanceof HTMLElement) {
      button.addEventListener('click', () => {
        const panelId = button.getAttribute('data-panel-trigger');
        if (panelId) {
          const panel = document.getElementById(panelId);
          if (panel && panel instanceof SlidePanel) {
            panel.open();
          }
        }
      });
    }
  });
});
